import { render, staticRenderFns } from "./MaterialsSettings.vue?vue&type=template&id=e78b0318"
import script from "./MaterialsSettings.vue?vue&type=script&lang=js"
export * from "./MaterialsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports